// extracted by mini-css-extract-plugin
export default {"root":"FactsComparisonCard_root__g4ik-","title":"FactsComparisonCard_title__QbYw-","chart":"FactsComparisonCard_chart__37X4+"};